<div
  fxLayout="column" fxLayoutAlign="start center"
  class="gd-app-loading-dialog-v2">
  <!-- Spinner -->
  <mat-progress-spinner
    class="gd-app-loading-dialog-v2-spinner"
    diameter="48"
    mode="indeterminate"></mat-progress-spinner>

  <!-- Message -->
  <div
    class="gd-app-loading-dialog-v2-message">
    <span
      *ngIf="data?.message"
      [innerHTML]="data.message | translate:data.messageData | safeHtml"></span>
  </div>
</div>
